import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	blockedBy: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocked-by',
		defaultMessage: 'blocked by',
		description:
			'Separator line label. Appears on the line between blocker and blocked issues in dependency tooltip.',
	},
	blocks: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocks',
		defaultMessage: 'blocks',
		description:
			'Separator line label. Appears on the line between blocked issue and blocker in dependency tooltip.',
	},
	dependencyOf: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.dependency-of',
		defaultMessage: 'Dependency of <b>{itemKey} {title}</b>',
		description: 'Dependency of label. Appears on the top of the dependency tooltip.',
	},
});
